import React from 'react';
import Content from './Content';

export default function MarathonLectures(): React.ReactNode {
  return (
    <div>
      <Content />
    </div>
  );
}
